import { DocumentSnapshotWithLinkPropertySerde } from "./DocumentSnapshotWithLinkPropertySerde";
/**
 * A static document snapshot repository is much simpler than a regular document snapshot repository, because it does not need
 * to support modifying the existing version data.  It can only read/write/check existence.
 */
export class DocumentSnapshotRepository {
    storageAdapter;
    serde;
    constructor(storageAdapter, serde = new DocumentSnapshotWithLinkPropertySerde()) {
        this.storageAdapter = storageAdapter;
        this.serde = serde;
    }
    /**
     * Get a static document snapshot object.
     */
    async get(descriptor) {
        const schemaTag = descriptor.schemaTag ?? this.serde.serializationSchemaTag;
        // TODO: can we avoid this copy?
        return this.storageAdapter.get({ schemaTag, ...descriptor }).then((rawPv) => {
            if (rawPv) {
                return this.serde.fromStored(rawPv);
            }
            return undefined;
        });
    }
    /**
     * Save a document snapshot object.
     */
    save(data, descriptor) {
        return this.storageAdapter.save(this.serde.intoStored(data), descriptor);
    }
    /**
     * Check to see if a static document snapshot object exists that satisfies the reference.
     */
    exists(descriptor) {
        const schemaTag = descriptor.schemaTag ?? this.serde.serializationSchemaTag;
        return this.storageAdapter.exists({ schemaTag, ...descriptor });
    }
}
//# sourceMappingURL=DocumentSnapshotRepository.js.map